import { useQuery } from '@tanstack/react-query'

interface TrialStatus {
  installed: string
  expires_on: string
  days_elapsed: number
  days_remaining: number
  is_expired: boolean
  is_warning: boolean
  edition: string
}

export function TrialBanner() {
  const { data } = useQuery<TrialStatus>({
    queryKey: ['trial'],
    queryFn: () => fetch('/api/trial/').then(r => r.json()),
    staleTime: 3_600_000,
    retry: false,
  })

  if (!data || (!data.is_expired && !data.is_warning)) return null

  if (data.is_expired) {
    return (
      <div className="fixed inset-0 bg-[var(--brand-primary-2)] z-[9999] flex items-center justify-center">
        <div className="text-center space-y-6 p-8">
          <div className="text-6xl">🏥</div>
          <h1 className="text-4xl font-bold text-white">هايلبورت</h1>
          <p className="text-xl text-[var(--sand)]">انتهت فترة التجربة المجانية (90 يوم)</p>
          <div className="bg-black/20 rounded-2xl p-6 space-y-3 max-w-md mx-auto">
            <p className="text-[var(--sand)] text-sm">للحصول على الترخيص:</p>
            <p className="text-white font-bold text-lg">📱 +964 770 XXX XXXX</p>
            <p className="text-[var(--brand-primary)]">heilport.app</p>
          </div>
          <p className="text-[#bab09a] text-xs">انتهت في: {data.expires_on}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-amber-500 text-white px-4 py-2 text-center text-sm font-medium">
      ⚠️ فترة التجربة تنتهي خلال {data.days_remaining} يوم — تواصل معنا للترخيص
    </div>
  )
}
